










































































































































import { Component } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import MyMixin from "@/mixins/datemixin";
import NumberTmpl from "@/ui-component/number.vue";

@Component({
  components: {
    NumberTmpl,
  },
})
export default class RecuUi extends mixins(MyMixin) {
  @Prop() public selectedRecu!: any;
  public dataGetted = false;
  public libFamilles = new Array();
  public errorComm = false;

  public mounted() {
    this.dataGetted = false;
    // console.log(this.selectedRecu);
    console.log(this.me);
    this.dataGetted = true;
    this.groupByLibFamille();
  }

  /**
   * reload on change
   */
  @Watch("selectedRecu", { immediate: true, deep: false })
  public onEvtChanged({ value, oldValue }: { value: any; oldValue: any }) {
    this.dataGetted = false;
    // console.log(this.selectedRecu.libSite, this.selectedRecu.tiroirReglements);
    this.groupByLibFamille();
    this.dataGetted = true;
  }

  public groupByLibFamille() {
    this.libFamilles = new Array();
    this.selectedRecu.tiroirReglements.forEach((regl: any) => {
      if (regl.totalReel !== 0 || regl.totalTheorique !== 0) {
        const fam = this.libFamilles.find(
          (r: any) => r.libFamille === regl.libFamille
        );
        if (!fam) {
          const maFam = {
            libelle: regl.libelle,
            libFamille: regl.libFamille,
            totalTheorique: regl.totalTheorique,
            totalReel: regl.totalReel,
            remarque: regl.remarque,
          };
          this.libFamilles.push(maFam);
        } else {
          fam.totalReel += regl.totalReel;
          fam.totalTheorique += regl.totalTheorique;
          fam.libelle += " " + regl.libelle;
        }
      }
    });
    this.libFamilles.sort((u1: any, u2: any) => {
      return u1.libFamille.localeCompare(u2.libFamille, undefined, {
        numeric: false,
        sensitivity: "base",
      });
    });
    // console.log(this.libFamilles);
  }

  public getCommentaire() {
    const mcmpl = this.selectedRecu.complements.find(
      (cmpl: any) => cmpl.cle === "CONTRE_SIGNATURE_COMMENTAIRE"
    );
    if (mcmpl) {
      return mcmpl.valeur;
    } else {
      return "";
    }
  }

  public getValidationInitiale() {
    const mcmpl = this.selectedRecu.complements.find(
      (cmpl: any) => cmpl.cle === "VALIDATION_HORODATAGE_INITIAL"
    );
    if (mcmpl) {
      return mcmpl.valeur;
    } else {
      return "";
    }
  }

  public contreSigne() {
    this.errorComm = false;
    if (
      this.selectedRecu.commentaire.trim() === "" ||
      !this.selectedRecu.commentaire.replace(/\s/g, "").length
    ) {
      this.errorComm = true;
      return;
    }
    this.$emit("contreSigne", this.selectedRecu);
  }

  public relanceDir() {
    this.$emit("relanceDir", this.selectedRecu);
  }

  public relanceDM() {
    this.$emit("relanceDM", this.selectedRecu);
  }

  get me(): any {
    return this.$store.getters["login/user"];
  }
}
